var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 340.29083 379.66412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ub",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: -0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(6,84,155)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "rgb(47,161,211)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "rgb(47,161,211)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lb",
    x1: 0,
    y1: 0.6,
    x2: 1,
    y2: -0.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(19,113,177)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "rgb(47,161,211)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "rgb(47,161,211)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "rgb(6,86,156)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ur",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: -0.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(157,26,54)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "rgb(157,26,54)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "rgb(230,25,47)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lr",
    x1: 0,
    y1: 0.6,
    x2: 1,
    y2: -0.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(162,28,56)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "rgb(230,25,47)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "rgb(230,25,47)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "rgb(167,28,55)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.7899,-39.8076)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.043997,1.043997)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0056a2"
  }, /*#__PURE__*/React.createElement("title", null, "Chevron"), /*#__PURE__*/React.createElement("path", {
    d: "M 85.154,100.157 C 82.687,101.361 77.705,102.844 70.316,102.844 C 49.855,102.844 38.113,88.771 38.113,70.816 C 38.113,49.441 53.075,38.13 71.675,38.13 C 78.886,38.13 82.696,39.51 85.15,40.814 L 82.877,53.597 C 80.145,52.387 77.245,51.285 72.237,51.285 C 63.379,51.285 53.983,56.553 53.983,70.58 C 53.983,83.128 61.475,89.765 72.311,89.765 C 76.603,89.765 79.516,88.923 82.878,87.38 L 85.154,100.157 z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 119.129,53.982 C 113.617,53.982 108.283,56.481 105.567,60.495 L 105.4,60.495 L 105.4,38.354 L 91.535,43.154 L 91.535,100.919 L 105.4,100.919 L 105.4,73.936 C 105.4,70.04 107.933,65.849 112.791,65.849 C 117.988,65.849 119.99,69.94 119.99,75.891 L 119.99,100.92 L 133.867,100.92 L 133.867,73.977 C 133.867,60.223 127.968,53.982 119.129,53.982 z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154.783,82.696 C 155.293,88.547 160.146,91.656 167.645,91.723 C 172.164,91.758 177.418,90.444 180.918,88.382 L 183.01,99.173 C 177.742,101.819 171.724,102.844 165.598,102.844 C 149.094,102.844 140.248,92.918 140.248,77.711 C 140.248,63.001 149.76,53.509 164.014,53.509 C 178.704,53.509 185.289,64.325 185.289,77.877 C 185.289,79.305 185.113,81.631 184.955,82.696 L 154.783,82.696 M 171.441,72.829 C 171.441,69.431 169.783,63.489 163.364,63.489 C 157.736,63.489 155.082,68.334 154.688,72.829 L 171.441,72.829 z "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.587,100.919 186.267,55.439 201.564,55.439 209.887,87.61 210.167,87.61 218.491,55.439 233.794,55.439 218.475,100.919 201.587,100.919 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237.725,70.396 C 237.725,63.705 237.515,59.34 237.23,55.438 L 250.292,55.438 L 250.688,63.892 L 251.039,63.892 C 253.325,57.201 257.712,54.659 262.224,54.403 C 264.369,54.278 265.53,54.43 266.858,54.687 L 266.858,67.985 C 265.587,67.736 263.065,67.443 261.292,67.606 C 255.956,68.097 252.727,71.978 251.821,76.446 C 251.639,77.372 251.545,78.4 251.545,79.603 L 251.545,100.918 L 237.73,100.918 L 237.73,70.396 L 237.725,70.396 z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 315.584,78.176 C 315.584,93.082 306.603,102.843 292.05,102.843 C 277.494,102.843 268.507,93.082 268.507,78.176 C 268.507,63.268 277.494,53.508 292.05,53.508 C 306.603,53.508 315.584,63.269 315.584,78.176 M 301.209,78.176 C 301.209,70.775 298.665,64.333 292.05,64.333 C 285.426,64.333 282.895,70.774 282.895,78.176 C 282.895,85.584 285.426,92.016 292.05,92.016 C 298.667,92.016 301.209,85.584 301.209,78.176 z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 321.75,69.939 C 321.75,64.263 321.542,59.417 321.249,55.439 L 334.311,55.439 L 334.61,61.802 L 334.89,61.802 C 336.699,58.843 341.486,53.982 348.955,53.982 C 358.096,53.982 364.063,60.223 364.063,73.611 L 364.063,100.92 L 350.21,100.92 L 350.21,75.701 C 350.21,69.849 348.202,65.848 343.189,65.848 C 339.345,65.848 336.958,68.551 336.072,71.142 C 335.744,72.091 335.61,73.38 335.61,74.682 L 335.61,100.919 L 321.75,100.919 L 321.75,69.939 L 321.75,69.939 z "
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "38.608,221.484 38.608,113.014 201.354,167.252 38.608,221.484 ",
    fill: "url(#ub)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.649,221.492 201.354,275.724 364.05,221.492 364.05,113.027 201.354,167.252 38.649,221.492 ",
    fill: "url(#lb)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.618,347.568 38.604,239.063 201.339,293.298 38.618,347.568 ",
    fill: "url(#ur)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.058,239.063 201.308,293.281 38.636,347.548 201.339,401.794 364.058,347.531 364.058,239.063 ",
    fill: "url(#lr)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterlogo);
export default __webpack_public_path__ + "static/media/filter.logo.d7d8b38c6888f2c06d6b106571f95076.svg";
export { ForwardRef as ReactComponent };